import { Component, HostBinding, inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Menu, MenuService } from '@core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MatTabNav, MatTabNavPanel } from '@angular/material/tabs';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { NgxPermissionsModule } from 'ngx-permissions';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatMenuTrigger } from '@angular/material/menu';
import { TopmenuPanelComponent } from './topmenu-panel.component';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

export interface TopmenuState {
  active: boolean;
  route: string;
}

@Component({
    selector: 'app-topmenu',
    templateUrl: './topmenu.component.html',
    styleUrls: ['./topmenu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [MatTabNav, NgxPermissionsModule, MatAnchor, RouterLinkActive, RouterLink, NgTemplateOutlet, MatButton, MatMenuTrigger, TopmenuPanelComponent, MatTabNavPanel, MatIcon, AsyncPipe, TranslateModule]
})
export class TopmenuComponent implements OnDestroy {
  private menu = inject(MenuService);
  private router = inject(Router);

  @HostBinding('class') class = 'matero-topmenu';

  menu$ = this.menu.getAll();

  buildRoute = this.menu.buildRoute;

  menuList: Menu[] = [];
  menuStates: TopmenuState[] = [];

  private menuSubscription = Subscription.EMPTY;
  private routerSubscription = Subscription.EMPTY;

  constructor() {
    this.menuSubscription = this.menu$.subscribe(res => {
      this.menuList = res;
      this.menuList.forEach(item => {
        this.menuStates.push({
          active: this.router.url.split('/').includes(item.route),
          route: item.route,
        });
      });
    });
  }

  ngOnDestroy() {
    this.menuSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
  }

  onRouteChange(rla: RouterLinkActive, index: number) {
    this.routerSubscription.unsubscribe();
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(e => {
        this.menuStates.forEach(item => (item.active = false));
        setTimeout(() => (this.menuStates[index].active = rla.isActive));
      });
  }
}
